import { useState, useEffect } from "react";
import LoadingModalComponent from "../../modals/loading-modal";
import { getPackages } from "../../api/services";
import { formatCurrency } from "../../helpers/currency";
import { useSearchParams } from "react-router-dom";
import CustomSearch from "../../components/search";
import CustomPagination from "../../components/pagination";
import CustomDateRangePicker from "../../components/date-picker";
import AllotModal from "../../modals/allot-modal";
import StatusFilterComponent from "../../components/status";
import { packageSearchTypes } from "../../configs/searchTypes";

export default function PackageListScreen() {
  const [searchParams, setSearchParams] = useSearchParams();
  const [showAllotModal, setShowAllotModal] = useState(false);
  const [selectedPackage, setSelectedPackage] = useState({});
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);

  const PACKAGES_PER_PAGE = 12;
  const statusId = searchParams.get("status") ? parseInt(searchParams.get("status")) : undefined;
  const page = searchParams.get("page") || 1;
  const range = searchParams.get("range");
  const phone = searchParams.get("phone") || null;
  const code = searchParams.get("code") || null;
  const driver = searchParams.get("driver") || null;
  const car = searchParams.get("car") || null;

  useEffect(() => {
    setLoading(true);
    getPackages({ phone, code, driver, range, statusId, car, limit: PACKAGES_PER_PAGE, offset: (page - 1) * PACKAGES_PER_PAGE })
      .then((res) => setData(res.data))
      .catch(console.error)
      .finally(() => setLoading(false));
  }, [phone, code, driver, range, statusId, car, page]);

  const handleStatusColor = (id) => {
    if (id === 1) return "info";
    if (id === 2) return "warning";
    if (id === 3) return "success";
    return "";
  };

  return (
    <div className="row">
      <div className="col-12">
        <div className="card">
          <LoadingModalComponent show={loading} />
          <AllotModal
            data={selectedPackage}
            show={showAllotModal}
            onHide={() => setShowAllotModal(false)}
            setShow={setShowAllotModal}
          />
          <div className="card-body">
            <div className="row mb-2">
              <div className="col-4">
                <CustomSearch searchTypes={packageSearchTypes} placeholder={"Дайвар хайх..."} />
              </div>
              <div className="col-2">
                <StatusFilterComponent />
              </div>
              <div className="col-2">
                <CustomDateRangePicker />
              </div>
              <div className="col-1">
                <a onClick={() => setSearchParams("")} className="btn border rounded">
                  <i className="mdi mdi-autorenew" />
                </a>
              </div>
            </div>
            <div className="table-responsive">
              <table className="table table-centered table-bordered mb-0">
                <thead>
                  <tr className="text-center">
                    <th className="fw-normal col">Код</th>
                    <th className="fw-normal col">Утас-1</th>
                    <th className="fw-normal col">Утас-2</th>
                    <th className="fw-normal col-2">Огноо</th>
                    <th className="fw-normal col">Төлөв</th>
                    <th className="fw-normal col">Жолооч</th>
                    <th className="fw-normal col">Төлбөр</th>
                    <th className="fw-normal col">Хадгалалт</th>
                    <th className="fw-normal col"></th>
                  </tr>
                </thead>
                <tbody>
                  {data?.data.map((k, i) => (
                    <tr key={i} className="text-center">
                      <td>{k?.code}</td>
                      <td>{k?.phone}</td>
                      <td>{k?.phone1}</td>
                      <td>{k?.createdAt}</td>
                      <td>
                        <small className={`badge badge-${handleStatusColor(k?.status?.id)}-lighten py-1 px-2 fw-normal text-uppercase`}>
                          {k?.status?.name}
                        </small>
                      </td>
                      <td>{k?.driver?.phone}</td>
                      <td>{formatCurrency(k?.amount)}</td>
                      <td>{formatCurrency(k?.profit)}</td>
                      <td>
                        <a
                          onClick={() => {
                            if (k?.status?.id === 1) {
                              setSelectedPackage(k);
                              setShowAllotModal(true);
                            }
                          }}
                          style={{ cursor: "pointer" }}
                          className="action-icon"
                        >
                          <i className={`mdi mdi-barcode-scan text-${k?.status?.id === 1 ? "info" : "light"}`} />
                        </a>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <CustomPagination total={data?.total} limit={PACKAGES_PER_PAGE} />
          </div>
        </div>
      </div>
    </div>
  );
}
